import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { DtmService } from 'src/app/services/dtm.service';
import { environment } from 'src/environments/environment';
import { Api } from '../enum/Api';
import { HttpService } from './http.service';
import { singlePlanProducts } from '../constants/single-plan-products';
import { stepsSinglePlan } from '../constants/steps-single-plan';
import { steps } from '../constants/steps';
import { Observable, lastValueFrom } from 'rxjs';
import { SessionStorageService } from './session-storage.service';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {
  isSinglePlan: boolean;
  mappedSteps: any;

  constructor(
    private httpService: HttpService,
    private dtmService: DtmService,
    private router: Router,
    private sessionStorageService: SessionStorageService
  ) {
    if (sessionStorage) {
      let classificationIdentifier = sessionStorage.getItem('classificationIdentifier');
      this.isSinglePlan = singlePlanProducts.includes(classificationIdentifier);

      if (this.isSinglePlan) {
        this.mappedSteps = stepsSinglePlan;
      } else {
        this.mappedSteps = steps;
      }
    }
  }

  validateQueryParams(params: any) {
    let isValid = true;
    for (let param of Object.values(params)) {
      if (!param || param === "undefined" || param === "null") {
        isValid = false;
        break;
      }
    }

    if (isValid) return true;

    this.dtmService.customErrorLoaded(['error'], {
      errorMessage: 'Parametrização incorreta na url',
    });

    return false;
  }

  returnToShopWindow() {
    let classificationIdentifier = this.sessionStorageService.getClassification();

    if(this.sessionStorageService.getAdditionalData("isCampaign")){
      classificationIdentifier+="-campanha";
    }

    const shopWindowRoute = this.sessionStorageService.getShopWindowRoute();
    let params : any = {
      userId: this.sessionStorageService.getUserId(),
      businessId: this.sessionStorageService.getBusinessId()
    }

    if (this.sessionStorageService.getCoupon()){
      params.coupon = this.sessionStorageService.getCoupon();
    }
    this.router.navigate([classificationIdentifier, "checkout", shopWindowRoute],{queryParams:params});
    
  }

  returnToLoginPage() {
    let env = environment.one_environment;
    return lastValueFrom(this.httpService.post('eCommercePME/urlConfig/getUrl', Api.One_Portal, { 'env': env })).then(res => {
      const baseUrl = res.serasaBaseUrl;

      window.location.href = baseUrl + "login";
    });
  }

  returnBaseUrl(): Observable<any> {
    let env = environment.one_environment;

    return this.httpService.post('eCommercePME/urlConfig/getUrl', Api.One_Portal, { 'env': env });
  }

  getCurrentStep() {
    let currentStep;

    Object.keys(this.mappedSteps).forEach(step => {
      if (this.router.url.indexOf(step) >= 0) {
        currentStep = this.mappedSteps[step];
      }
    });

    return currentStep;
  }

  public createAdobeAnalyticsLog(method: string, error: string, input: string): Observable<any> {
    return this.httpService.post(
      'eCommercePME/eCommerceAPI/createAdobeAnalyticsErrorLog',
      Api.One_Portal,
      {
        'method': method,
        'error': error,
        'methodInput': input
      }
    )
  }
}
